import { Col, Divider, Row, Radio, message, Input, DatePicker, Checkbox } from "antd";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomSelect from "../../Components/CustomSelectBelstar";
import { SectionCardWrapper } from "../../Components/UI/SectionCardWrapper";
import axios from "axios";
import {
    Agent_optiom,
    CustomLabel,
    DEA_RENEWAL_QUICKPAY_CONSTANT,
    error_message,
    format_amount,
    getURlParameter,
    payment_option,
    // payment_option_only_asba,
    payment_option_with_upi,
    reason_for_quickpay,
    regex,
    TYPE_OF_VALIDATION,
    validationOfField,
} from "../../Constant";
import { RESET_RESPONSE_POLICY } from "../../Redux/ErrorResponse/types";
import {
    GET_POLICY_DETAILS,
    GET_POLICY_INVOKE,
    Payload_entry,
    SAVE_PAYMENT,
    SET_UPI_ASBA_FLAG,
    SAVE_BELSTAR_PAYMENT,
    SAVE_BELSTAR_AVAILABILITY
} from "../../Redux/PolicyNumber/types";
import { postApi, getApi } from "../../Services/apiService";
import { GET_POLICY, SAVE_PAYMENT_DETAILS, IS_BLOCK_POLICY, GET_POLICY_PAYMENT } from "../../Services/endpoints";
import FooterButton from "../Footer";
import InputFormComponent from "./InputFormComponentBelstar";
import CheckboxConsentBelstar from "./SummaryBelstarPage/CheckBoxConsentBelstar";
import { decrypt, encrypt } from "../../Services/AESEncryptionDecryption";
import "./style.css";
import { useCaptcha } from "../../Utils/recaptcha";
import { withScroll } from "../../HOC";
const STATIC_DATA = {
    New_Application: "New Business",
    Agent_Recruitment: "Agent Recruitment",
    Renewal: "Renewal",
    UPI_ASBA: "UPI ASBA"
};

let agent_details_data = {
    proposalType: STATIC_DATA.Agent_Recruitment,
    paymentFor: "Agent Recruitment Fee",
    policyNumber: null,
    proposalNumber: "",
    amount: 627.0,
};

dayjs.extend(customParseFormat);
const dateFormat = 'DD/MM/YYYY';

const Belstar = ({ isCampaign = false }) => {
    const renewalBaseUrl = process.env.REACT_APP_RENEWAL_URL;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDBData = useSelector((state) => state.policyDetails);
    const [memberSalutation, setMemberSalutation] = useState("");
    const [memberName, setMemberName] = useState("");
    const [memberLastName, setMemberLastName] = useState("");
    const [memberEmail, setMemberEmail] = useState(null);
    const [memberMobile, setMemberMobile] = useState(null);
    const [memberDOB, setMemberDOB] = useState(null);
    const [memberAddress1, setMemberAddress1] = useState();
    const [memberAddress2, setMemberAddress2] = useState();
    const [memberAddress3, setMemberAddress3] = useState();
    const [memberGender, setMemberGender] = useState("");
    const [pinCode, setPincode] = useState();
    const [loanId, setLoanId] = useState();
    const [sumInsured, setSumInsured] = useState("2000 per day");
    const [nomineeName, setNomineeName] = useState("");
    const [nomineeAge, setNomineeAge] = useState("");
    const [nomineeDOB, setNomineeDOB] = useState("");
    const [nomineeRelationship, setNomineeRelationship] = useState("");
    const [branchId, setBranchId] = useState("");
    const [productName, setProductName] = useState("HospiCash");
    const [preExistingDisease, setPreExistingDisease] = useState("");
    const [GHD1, setGHD1] = useState(true);
    const [GHD2, setGHD2] = useState(true);
    const [disableField, setDisableField] = useState({
        PoNum: false,
        amount: false,
        comments: false,
        reason: false,
        payFor: false,
        name: false,
    });
    const [error, setError] = useState({
        memberSalutationError: false,
        memberNameError: false,
        memberLastNameError: false,
        memberEmailError: false,
        memberMobileError: false,
        memberDOBError: false,
        memberGenderError: false,
        memberAddress1Error: false,
        memberAddress2Error: false,
        memberAddress3Error: false,
        productNameError: false,
        pinCodeError: false,
        loanIdError: false,
        branchIdError: false,
        sumInsuredError: false,
        memberRelationshipError: false,
        nomineeNameError: false,
        // nomineeAgeError: false,
        nomineeDOBError: false,
        preExistingDiseaseError: false,
        nomineeRelationshipError: false,
    });
    const [userData, setUserData] = useState({
        PoNum: "",
        amount: null,
        name: "",
        mobile: "",
        email: "",
        agentNo: "",
    });

    const { PoNum, amount, name, mobile, email, agentNo } = userData;
    const {
        PoNumError,
        amountError,
        nameError,
        mobileError,
        emailError,
        agentNoError,
    } = error;

    const {
        nextPremiumDueDt,
        nextInstalmentAmt,
        premiumToBeCollected,
        paymentFrequencyCd,
        baseAgentId,
        receiptBranchId,
        partyAddressSeq,
        priority,
        contactTypeCd,
        contactNum,
        extensionNum,
        stdCode,
        preferredFl,
        emailTypeCd,
        statusCd,
        firstName,
        lastName,
        emailAddress,
        getPolicyHit,
    } = userDBData;

    const commmonObj = { PoNum, amount };
    const premiumObj = { PoNum, name, email, mobile };
    const installmentObj = { PoNum };
    const AgentObj = { agentNo };
    const commmonObjError = { PoNumError, amountError };
    const premiumObjError = {
        PoNumError,
        amountError,
        nameError,
        emailError,
        mobileError,
    };
    const installmentObjError = { PoNumError };
    const AgentObjError = { agentNoError };
    const { New_Application, Agent_Recruitment, Renewal, UPI_ASBA } = STATIC_DATA;
    // const { handleReCaptchaVerify, captchaToken } = useCaptcha();
    const [bypassCalled, setBypassCalled] = useState(false);
    // const isUpiAsba = applicationType === UPI_ASBA || paymentSelect === "UPI_ASBA"

    // const onAPiCall = async () => {
    //     const newToken = await handleReCaptchaVerify();
    //     try {
    //         const response = await getApi(`${IS_BLOCK_POLICY}?pno=${PoNum}`, { baseURL: renewalBaseUrl });
    //         if (response?.data?.response) {
    //             message.error(`We are unable to retrieve your policy details, please get in touch with distributor/branch.`);
    //             return;
    //         }
    //     }
    //     catch (err) {
    //         message.error(error_message?.common_error);
    //     }

    //     if (applicationType === Renewal && paymentSelect === payment_option[0].value) {
    //         const demoObj = {
    //             token: newToken,
    //             listofPolicyDetailsTO: [
    //                 {
    //                     policyNum: `${applicationType === Renewal ? PoNum : ""}`,
    //                     applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
    //                 },
    //             ],
    //         };

    //         if (reason.length === 0 || comment.length === 0) {
    //             return setReason_error(true);
    //         } else {
    //             setReason_error(false);
    //             try {
    //                 const encryptedObj = encrypt(JSON?.stringify(demoObj))
    //                 const response = await postApi(GET_POLICY, {
    //                     encodedString: encryptedObj
    //                 });
    //                 if (response?.data?.response) {
    //                     const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
    //                     await dispatch({
    //                         type: GET_POLICY_DETAILS,
    //                         payload: decryptedRes,
    //                     });
    //                     await dispatch({ type: GET_POLICY_INVOKE, payload: true });
    //                     await savePaymentDetails(amount);
    //                 } else {
    //                     message.error(response?.data?.error?.errorMessage);
    //                 }
    //             } catch (err) {
    //                 message.error(err?.errorMessage ?? "Something went wrong")
    //             }
    //         }
    //         return;
    //     }
    //     if (applicationType === Agent_Recruitment) {
    //         agent_details_data.policyNumber = agentNo;
    //         await dispatch({ type: GET_POLICY_INVOKE, payload: true });
    //         await dispatch({ type: SAVE_PAYMENT, payload: agent_details_data });
    //         savePaymentDetails(amount);
    //         return;
    //     }

    //     if (
    //         applicationType === New_Application &&
    //         paymentSelect == payment_option[0].value && !isPaymentFirst
    //     ) {
    //         return checkNSTPFlag();
    //     }

    //     const data = {
    //         token: newToken,
    //         listofPolicyDetailsTO: [
    //             {
    //                 policyNum: `${applicationType === Renewal ? PoNum : ""}`,
    //                 applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
    //             },
    //         ],
    //     };

    //     try {
    //         const encryptedObj = encrypt(JSON?.stringify(data))
    //         const response = await postApi(GET_POLICY, {
    //             encodedString: encryptedObj
    //         });
    //         if (response?.data?.response) {
    //             const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
    //             dispatch({
    //                 type: GET_POLICY_DETAILS,
    //                 payload: decryptedRes,
    //             });
    //             dispatch({ type: GET_POLICY_INVOKE, payload: true });
    //             if (isUpiAsba && decryptedRes?.statusCd?.toString()?.toLowerCase() !== "pending") {
    //                 message?.error("ASBA registration can only be done for Pending policies.")
    //             }
    //         }
    //         else {
    //             message.error(response?.data?.error?.errorMessage);
    //         }
    //     } catch (err) {
    //         if ((isCampaign || isPaymentFirst) && applicationType === New_Application) {
    //             dispatch({ type: Payload_entry, payload: { name: name } });
    //             savePaymentDetails(amount)
    //         }
    //         else {
    //             message.error(err?.errorMessage ?? "Something went wrong")
    //         }
    //     }
    // };

    // const checkNSTPFlag = async () => {
    //     const newToken = await handleReCaptchaVerify();
    //     const data = {
    //         token: newToken,
    //         listofPolicyDetailsTO: [
    //             {
    //                 policyNum: `${applicationType === Renewal ? PoNum : ""}`,
    //                 applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
    //             },
    //         ],
    //     };

    //     try {
    //         const encryptedObj = encrypt(JSON?.stringify(data));
    //         const response = await postApi(GET_POLICY_PAYMENT, {
    //             encodedString: encryptedObj,
    //         });
    //         if (response?.data?.response) {
    //             const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
    //             if (decryptedRes?.proccedToPayment === "Yes" || isCampaign) {
    //                 dispatch({ type: Payload_entry, payload: { name: name } });
    //                 return savePaymentDetails(decryptedRes?.premiumToBeCollected);
    //             }
    //             else {
    //                 message?.error(decryptedRes?.message)
    //             }
    //         } else {
    //             message.error(response?.data?.error?.errorMessage || error_message?.common_error);
    //         }
    //     } catch (err) {
    //         message.error(err?.errorMessage || error_message?.common_error);
    //     }
    // }
    const [uniqueId, setUniqueId] = useState();
    useEffect(() => {
        const getUniqueId = async () => {
            const identifier = await axios.get(`${process.env.REACT_APP_URL}v1/getIdentifer`);
            setUniqueId(identifier?.data?.response)
        }
        getUniqueId()
        // return () => { }
    }, [])

    const savePaymentDetails = async (amount) => {
        const responseObject = {
            memberSalutation: memberSalutation,
            memberName: memberName,
            memberLastName: memberLastName,
            memberEmail: memberEmail,
            memberMobile: parseInt(memberMobile),
            memberDOB: memberDOB,
            memberGender: memberGender,
            memberAddress1: memberAddress1,
            memberAddress2: memberAddress2,
            memberAddress3: memberAddress3,
            pinCode: pinCode,
            loanId: loanId,
            branchId: branchId,
            sumInsured: "2000",
            nomineeName: nomineeName,
            nomineeDOB: nomineeDOB,
            nomineeRelationship: nomineeRelationship,
            productName: productName,
            preExistingDisease: preExistingDisease,
            GHD1: GHD1,
            GHD2: GHD2,
            uniqueIdentifier: uniqueId,


            // memberSalutation: "Mr",
            // memberName: "test",
            // memberLastName: "test",
            // memberEmail: "test",
            // memberMobile: 7459027503,
            // memberDOB: "23/02/1970",
            // memberGender: "test",
            // memberAddress1: "test",
            // memberAddress2: "test",
            // memberAddress3: "test",
            // pinCode: "test",
            // loanId: "test",
            // branchId: "test",
            // sumInsured: "2000",
            // memberRelationship: "test",
            // nomineeName: "test",
            // nomineeAge: 30,
            // nomineeRelationship: "test",
            // uniqueIdentifier: uniqueId
        };

        // dispatch({ type: SAVE_PAYMENT, payload: save_details_data });

        try {
            const encryptedObj = encrypt(JSON?.stringify(responseObject))
            const res = await axios.post(`${process.env.REACT_APP_URL}v1/saveUserFormDetails`, {
                encodedString: encryptedObj,
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );
            dispatch({ type: SAVE_BELSTAR_AVAILABILITY, payload: { isVendorBelstar: true, uniqueIdentifier: uniqueId } });
            dispatch({ type: SAVE_BELSTAR_PAYMENT, payload: { ...responseObject, productName, preExistingDisease } });
           
            navigate("/belstar-summary");
            // const saveAmount = (applicationType === UPI_ASBA || (paymentSelect === "UPI_ASBA")) ? premiumToBeCollected : nextInstalmentAmt;
            // if (res?.data?.response) {
            //     const decryptedRes = JSON.parse(decrypt(res?.data?.response))
            //     if (decryptedRes?.id) {
            //         if (
            //             !decryptedRes?.nextPremiumDueDt &&
            //             decryptedRes?.paymentFor === "Instalment"
            //         ) {
            //             return message.error(
            //                 "You are not currently eligible for Installment payment"
            //             );
            //         }
            //         if (applicationType !== Agent_Recruitment) {
            //             dispatch({
            //                 type: SAVE_PAYMENT,
            //                 payload: {
            //                     ...decryptedRes,
            //                     amount: !!amount ? amount : saveAmount,
            //                 },
            //             });
            //         }
            //         //SETTING ASBA FLAG
            //         dispatch({ type: SET_UPI_ASBA_FLAG, payload: isUpiAsba });
            //         //Navigate to summary
            //         navigate("/summary");
            //     }
            // }
            // else {
            //     message.error(res?.data?.error?.errorMessage);
            // }
        } catch (err) {
            console.error(err, "save payment details")

        }
    };

    const getSalutationOptions = () => {
        return [{ name: "Mr.", value: "Mr." }, { name: "Mrs.", value: "Mrs." }, { name: "Ms.", value: "Ms." }]
    }

    const getNomineeRelationshipOptions = () => {
        return [
            { name: "Father", value: "Father" },
            { name: "Mother", value: "Mother" },
            { name: "Husband", value: "Husband" },
            { name: "Wife", value: "Wife" },
            { name: "Son", value: "Son" },
            { name: "Daughter", value: "Daughter" },
            { name: "Son-in-Law", value: "Son-in-Law" },
            { name: "Daughter-in-law", value: "Daughter-in-law" },
            { name: "Father-in-law", value: "Father-in-law" },
            { name: "Mother-in-law", value: "Mother-in-law" },
            { name: "Others", value: "Others" },

        ]
    }

    const getGenderOptions = () => {
        return [{ name: "Male", value: "Male" }, { name: "Female", value: "Female" }]
    }

    const getProductOptions = () => {
        return [{ name: "HospiCash", value: "HospiCash" }]
    }

    const showProceedBtn = () => {
        const allFields = {
            memberSalutation: memberSalutation,
            memberName: memberName,
            memberLastName: memberLastName,
            // memberEmail: memberEmail,
            memberMobile: memberMobile,
            memberDOB: memberDOB,
            memberGender: memberGender,
            memberAddress1: memberAddress1,
            memberAddress2: memberAddress2,
            memberAddress3: memberAddress3,
            pinCode: pinCode,
            loanId: loanId,
            branchId: branchId,
            sumInsured: "2000 per day",
            nomineeName: nomineeName,
            nomineeDOB: nomineeDOB,
            nomineeRelationship: nomineeRelationship,
            productName: productName,
            // preExistingDisease: preExistingDisease,
        }
        console.error(error, "field error")
        return Object.values(error).every((value) => value === false) && Object.values(allFields).every((value) => value !== "")
        // return true;
    }


    return (
        <div className="container">
            <Row className={"cls_row_b97d89"}>
                <Col lg={24} md={20} xs={24}>
                    <SectionCardWrapper>
                        <Row>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Salutation</CustomLabel>
                                <CustomSelect
                                    style={{ width: "75%" }}
                                    selectOption={getSalutationOptions()}
                                    // placeholder="Select Member Salutation"
                                    onSelectClick={(e) => {
                                        setMemberSalutation(e);
                                    }}
                                    value={memberSalutation}
                                // disabled={disableField?.payFor}
                                />
                                <Divider />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Name</CustomLabel>
                                <InputFormComponent
                                    label={"Member Name"}
                                    className="user-input"
                                    name="Member Name"
                                    placeholder="Name"
                                    regex={regex.name}
                                    value={memberName}
                                    error={error.memberNameError}
                                    msg={"Enter Name"}
                                    onChange={(e) => {
                                        setMemberName(e.target.value)
                                        setError({
                                            ...error,
                                            ...{
                                                memberNameError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                    }
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Last Name</CustomLabel>
                                <InputFormComponent
                                    label={"Member Last Name"}
                                    className="user-input"
                                    name="Member Last Name"
                                    placeholder="Name"
                                    regex={regex.name}
                                    value={memberLastName}
                                    error={error.memberLastNameError}
                                    msg={"Enter Last Name"}
                                    onChange={(e) => {
                                        setMemberLastName(e.target.value)
                                        setError({
                                            ...error,
                                            ...{
                                                memberLastNameError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                    }
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Email</CustomLabel>
                                <InputFormComponent
                                    label={"Member Email"}
                                    className="user-input"
                                    name="Member Email"
                                    placeholder="Email"
                                    regex={regex.email}
                                    value={memberEmail}
                                    error={error.memberEmailError}
                                    msg={"Enter valid Email"}
                                    onChange={(e) => {
                                        // setError({
                                        //     ...error,
                                        //     ...{
                                        //         memberEmailError: validationOfField(
                                        //             TYPE_OF_VALIDATION.email,
                                        //             e.target.value
                                        //         ),
                                        //     },
                                        // });
                                        setMemberEmail(e.target.value)
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Mobile</CustomLabel>
                                <InputFormComponent
                                    label={"Member Mobile"}
                                    className="user-input"
                                    name="Member Mobile"
                                    placeholder="****45***"
                                    value={memberMobile}
                                    maxlength={10}
                                    error={error.memberMobileError}
                                    msg={"Enter valid Phone Number"}
                                    regex={regex.numeric_only}
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                memberMobileError: validationOfField(
                                                    TYPE_OF_VALIDATION.Mobile,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setMemberMobile(e.target.value)
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member DOB</CustomLabel>
                                <DatePicker style={{ width: '75%' }} defaultValue={null} format={dateFormat} onChange={(value) => {
                                    setMemberDOB(value)
                                    setError({
                                        ...error,
                                        ...{
                                            memberDOBError: validationOfField(
                                                TYPE_OF_VALIDATION.required,
                                                value
                                            ),
                                        },
                                    });
                                }} />
                                {/* <InputFormComponent
                                    label={"Member DOB"}
                                    className="user-input"
                                    name="DOB"
                                    value={memberDOB}
                                    maxlength={60}
                                    msg={"Enter DOB"}
                                    regex={regex.common}
                                    placeholder="DOB"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                memberEmailError: validationOfField(
                                                    TYPE_OF_VALIDATION.email,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setMemberDOB(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                /> */}
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Gender</CustomLabel>
                                <CustomSelect
                                    style={{ width: "75%" }}
                                    selectOption={getGenderOptions()}
                                    placeholder="Select From Below Option"
                                    onSelectClick={(e) => {
                                        setMemberGender(e);
                                        setError({
                                            ...error,
                                            ...{
                                                memberGenderError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e
                                                ),
                                            },
                                        });
                                    }}
                                    value={memberGender}
                                // disabled={disableField?.payFor}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Address1</CustomLabel>
                                <InputFormComponent
                                    label={"Member Address1"}
                                    className="user-input"
                                    name="Member Address1"
                                    value={memberAddress1}
                                    maxlength={60}
                                    error={error.memberAddress1Error}
                                    msg={"Enter Address"}
                                    regex={regex.common}
                                    placeholder="Address 1"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                memberAddress1Error: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setMemberAddress1(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Address2</CustomLabel>
                                <InputFormComponent
                                    label={"Member Address2"}
                                    className="user-input"
                                    name="Member Address2"
                                    value={memberAddress2}
                                    maxlength={60}
                                    error={error.memberAddress2Error}
                                    msg={"Enter Address"}
                                    regex={regex.common}
                                    placeholder="Address 2"
                                    onChange={(e) => {
                                        setMemberAddress2(e.target.value);
                                        setError({
                                            ...error,
                                            ...{
                                                memberAddress2Error: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member Address3</CustomLabel>
                                <InputFormComponent
                                    label={"Member Address3"}
                                    className="user-input"
                                    name="Member Address3"
                                    value={memberAddress3}
                                    maxlength={60}
                                    error={error.memberAddress3Error}
                                    msg={"Enter Address"}
                                    regex={regex.common}
                                    placeholder="Address 3"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                memberAddress3Error: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setMemberAddress3(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Member PinCode</CustomLabel>
                                <InputFormComponent
                                    label={"Member PinCode"}
                                    className="user-input"
                                    name="Pincode"
                                    value={pinCode}
                                    maxlength={6}
                                    minLength={6}
                                    error={error.pinCodeError}
                                    msg={"Enter Valid Pincode"}
                                    regex={regex.numeric_only}
                                    placeholder="******"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                pinCodeError: validationOfField(
                                                    TYPE_OF_VALIDATION.pincode,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setPincode(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Loan Id</CustomLabel>
                                <InputFormComponent
                                    label={"Loan Id"}
                                    className="user-input"
                                    name="LoanId"
                                    value={loanId}
                                    maxlength={60}
                                    error={error.loanIdError}
                                    msg={"Enter LoanId"}
                                    regex={regex.common}
                                    placeholder="LoanId"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                loanIdError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setLoanId(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Product Name</CustomLabel>
                                <CustomSelect
                                    style={{ width: "75%" }}
                                    selectOption={getProductOptions()}
                                    disabled={true}
                                    // placeholder="Select From Below Option"
                                    onSelectClick={(e) => {
                                        setProductName(e);
                                        setError({
                                            ...error,
                                            ...{
                                                productNameError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e
                                                ),
                                            },
                                        });
                                    }}
                                    value={productName}
                                // disabled={disableField?.payFor}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Sum Insured*</CustomLabel>
                                <InputFormComponent
                                    label={"Sum Insured"}
                                    className="user-input"
                                    name="Sum Insured"
                                    value={sumInsured}
                                    disabled={true}
                                    maxlength={60}
                                    error={error.sumInsuredError}
                                    msg={"Enter Sum Insured"}
                                    regex={regex.common}
                                    placeholder="Sum Insured"
                                    onChange={(e) => {
                                        // setError({
                                        //     ...error,
                                        //     ...{
                                        //         emailError: validationOfField(
                                        //             TYPE_OF_VALIDATION.email,
                                        //             e.target.value
                                        //         ),
                                        //     },
                                        // });
                                        setSumInsured(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Branch ID</CustomLabel>
                                <InputFormComponent
                                    label={"Branch ID"}
                                    className="user-input"
                                    name="Branch ID"
                                    value={branchId}
                                    maxlength={60}
                                    error={error.branchIdError}
                                    msg={"Enter Branch Id"}
                                    regex={regex.common}
                                    placeholder="Branch Id"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                branchIdError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setBranchId(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Nominee Name</CustomLabel>
                                <InputFormComponent
                                    label={"Nominee Name"}
                                    className="user-input"
                                    name="Nominee Name"
                                    value={nomineeName}
                                    maxlength={60}
                                    error={error.nomineeNameError}
                                    msg={"Enter Nominee Name"}
                                    regex={regex.common}
                                    placeholder="Nominee Name"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                nomineeNameError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setNomineeName(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Nominee DOB</CustomLabel>
                                <DatePicker style={{ width: '75%' }} defaultValue={null} format={dateFormat} onChange={(value) => {
                                    setNomineeDOB(value)
                                    setError({
                                        ...error,
                                        ...{
                                            nomineeDOBError: validationOfField(
                                                TYPE_OF_VALIDATION.required,
                                                value
                                            ),
                                        },
                                    });
                                }} />
                                {/* <InputFormComponent
                                    label={"Nominee DOB"}
                                    className="user-input"
                                    name="Nominee DOB"
                                    value={nomineeDOB}
                                    // error={error.emailError}
                                    maxlength={60}
                                    msg={"Enter Nominee DOB"}
                                    regex={regex.common}
                                    placeholder="Nominee DOB"
                                    onChange={(e) => {
                                        setError({
                                            ...error,
                                            ...{
                                                emailError: validationOfField(
                                                    TYPE_OF_VALIDATION.email,
                                                    e.target.value
                                                ),
                                            },
                                        });
                                        setNomineeDOB(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                /> */}
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <CustomLabel>Pre-Existing Disease(If any)</CustomLabel>
                                <InputFormComponent
                                    label={"Pre-Existing Disease(If any)"}
                                    className="user-input"
                                    name="Pre-Existing Disease"
                                    value={preExistingDisease}
                                    maxlength={60}
                                    error={error.preExistingDiseaseError}
                                    msg={"Enter Pre-Existing Disease"}
                                    regex={regex.commonIncludingComma}
                                    placeholder="Pre-Existing Disease"
                                    onChange={(e) => {
                                        // setError({
                                        //     ...error,
                                        //     ...{
                                        //         preExistingDiseaseError: validationOfField(
                                        //             TYPE_OF_VALIDATION.required,
                                        //             e.target.value
                                        //         ),
                                        //     },
                                        // });
                                        setPreExistingDisease(e.target.value);
                                        // return setUserData({
                                        //     ...userData,
                                        //     ...{ email: e.target.value },
                                        // });
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12}>
                                <CustomLabel>Nominee Relationship With Member</CustomLabel>
                                <CustomSelect
                                    style={{ width: "75%" }}
                                    selectOption={getNomineeRelationshipOptions()}
                                    // placeholder="Select From Below Option"
                                    onSelectClick={(e) => {
                                        setNomineeRelationship(e);
                                        setError({
                                            ...error,
                                            ...{
                                                nomineeRelationshipError: validationOfField(
                                                    TYPE_OF_VALIDATION.required,
                                                    e
                                                ),
                                            },
                                        });
                                    }}
                                    value={nomineeRelationship}
                                // disabled={disableField?.payFor}
                                />
                            </Col>

                        </Row>
                        <Row
                            justify="space-between"
                            align="top"
                            gutter={[0, { lg: 40 }]}
                            className={"cls_mghuntex_ec4138"}
                        >
                            <Col span={24} offset={0}>
                                <div
                                // className={"cls_mghuntk6_92615c"}
                                >
                                    <p className={"cls_mghuntk6_32242d"}>
                                        <strong>Good Health Declaration:</strong>
                                        <br />
                                        <Checkbox
                                            checked={GHD1}
                                            onChange={(e) => setGHD1(e.target.checked)}
                                        />
                                        {"  Have you or any member proposed for insurance, ever been diagnosed or treated for issues related to Cancer, tumour, Coronary Artery Bypass Graft, Heart Valve Replacement/Repair, Coma, Kidney Failure, chronic liver disease, Chronic Kidney disease, Stroke, Any Transplant, Paralysis, Multiple Sclerosis, GBS, Motor Neuron Disease, Haemolytic anaemia, rheumatoid arthritis, Sjogren syndrome, Ankylosing spondylitis, autoimmune conditions, Ulcerative Colitis or Crohn’s disease, Hepatitis B, Cirrhosis, Parkinsonism, Alzheimer’s, Multiple sclerosis, Brain Tumor, Cerebral Palsy, Chronic Bronchitis, Interstitial Lung Diseases, deep vein thrombosis, atherosclerosis, pancreatitis, IBD, psychiatric illness?"}
                                    </p>
                                </div>
                                <div
                                // className={"cls_mghuntk6_92615c"}
                                >
                                    <p className={"cls_mghuntk6_32242d"}>
                                        <Checkbox
                                            checked={GHD2}
                                            onChange={(e) => setGHD2(e.target.checked)}
                                        />
                                        {" Have you or any of the persons proposed for insurance, recommended to undergo any surgery in last 12 months?"}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <div>
                            <FooterButton
                                hideBack={true}
                                nextLabel="Proceed"
                                // onNext={onAPiCall}
                                onNext={(e) => {
                                    e.preventDefault();
                                    savePaymentDetails()
                                }}
                                disableNext={!showProceedBtn()}
                            />
                        </div>
                        <div>
                            <p><b>Note : </b>Sum Insured is valid upto 15 days in a year</p>
                        </div>
                    </SectionCardWrapper>
                </Col>
            </Row>
        </div>
    );
};

export default withScroll(Belstar);